import { render } from "./ListAgenciesSubParentView.vue?vue&type=template&id=7e9bb25b"
import script from "./ListAgenciesSubParentView.vue?vue&type=script&lang=js"
export * from "./ListAgenciesSubParentView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJECT\\LAI\\IDENTITY_IDENTIFIED\\Vue\\GIT\\crud-article-identity-identified\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__